import { Box, Button } from "@mui/material";
import { CsHeader } from "@com.ctu.iotlab/ui-library";
import { useKeycloak } from "src/contexts/KeycloakContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AccountMenu from "./AccountMenu";


function HeaderObs() {
    const { authenticated } = useKeycloak();
    const navigate = useNavigate()
    const { t } = useTranslation()
    
    return (
        <CsHeader >
            <Box sx={{ display: "flex", gap: 1 }}>
                {/* <CsLocale /> */}
                {authenticated ? <AccountMenu /> : <Button variant="text" onClick={() => navigate("/login")}>{t("Đăng nhập")}</Button>}
            </Box>
        </CsHeader>
    );
}

export default HeaderObs;